import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const TOUR_OPTIONS_BASE_QUERY_KEY = 'tourOptions';

export const tourOptionsApiQueryKeys = {
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, TOUR_OPTIONS_BASE_QUERY_KEY] as const,
  usageByOptionId: (optionId: string) =>
    [TOUR_OPTIONS_BASE_QUERY_KEY, optionId, 'usage'] as const,
};
